import { render, staticRenderFns } from "./FancyButton.vue?vue&type=template&id=0c951a47&"
import script from "./FancyButton.vue?vue&type=script&lang=js&"
export * from "./FancyButton.vue?vue&type=script&lang=js&"
import style0 from "./FancyButton.vue?vue&type=style&index=0&id=0c951a47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports